import { useCallback, useMemo } from "react"

import { DateFormatType, formatDate } from "~/utils/datetime"
import { formatFiscalWeekLabel, getFiscalConfig } from "~/utils/fiscalCalendar"

import { useCompany } from "./useCompany"

export function useFiscalWeek() {
  const { data: company } = useCompany()
  const fiscalConfig = useMemo(() => getFiscalConfig(company), [company])

  const formatWeek = useCallback(
    (date: Date, formatType: DateFormatType = DateFormatType.Week): string =>
      fiscalConfig
        ? formatFiscalWeekLabel(date, fiscalConfig, formatType)
        : formatDate(date, formatType),
    [fiscalConfig],
  )

  return { isFiscal: fiscalConfig !== null, fiscalConfig, formatWeek }
}
